export const APP_VERSION = '1.61'

export const API = process.env.REACT_APP_URL_API

export const apiUrl = (subdomain, path) => {
  const base = apiBaseUrl(subdomain)

  return `${base}${path}`
}

export const apiBaseUrl = (subdomain) => {
  return API.replace('https://', `https://${subdomain}.`)
};

export const API_LOGIN = (subdomain) => {
  /* cabeceada pero como no estamos sobre https
       no remplaza para localhost */
  const url = API.replace('https://', 'https://' + subdomain)
  return `${url}login_check`
}

export const defaultSubdomian = 'app'

export const VENDOR_STATUS_UNASSIGNED = 'Unassigned'
export const VENDOR_STATUS_PENDING = 'Pending'
export const VENDOR_STATUS_IN_PROGRESS = 'In Progress'
export const VENDOR_STATUS_NEGOTIATING = 'Negotiating'
export const VENDOR_STATUS_CONFIRMED = 'Confirmed'

export const CATLOG_FORMAT_XTM = 1
export const CATLOG_FORMAT_SALESFORCE = 2

export const PURCHASE_ORDER_STATUS_ACCEPTED = 'Accepted'
export const PURCHASE_ORDER_STATUS_IN_REVIEW = 'In Review'
export const PURCHASE_ORDER_STATUS_PAID = 'Paid'

export const INVOICE_STATUS_ACCEPTED = 'Accepted'
export const INVOICE_STATUS_IN_REVIEW = 'In Review'
export const INVOICE_STATUS_PAID = 'Paid'

export const TIMELINE_LQA_INTERNAL = 'Internal'
export const TIMELINE_LQA_CLIENT = 'Client'
export const TIMELINE_LQA_EXTERNAL = 'External'

/**
 * Users
 */
export const ROLE_TYPE_ADMIN = 'ROLE_TYPE_ADMIN'
export const ROLE_TYPE_MANAGER = 'ROLE_TYPE_MANAGER'
export const ROLE_TYPE_VENDOR = 'ROLE_TYPE_VENDOR'

export const USER_TYPES = [
  /*    { label: "Admin", value: ROLE_TYPE_ADMIN },*/
  { label: 'Manager', value: ROLE_TYPE_MANAGER },
  { label: 'Vendor', value: ROLE_TYPE_VENDOR },
]

export const MANAGER_GROUP_ADMIN = 'ROLE_MANAGER_ADMIN'
export const MANAGER_GROUP_FINANCE = 'ROLE_MANAGER_FINANCE'
export const MANAGER_GROUP_PROJECT = 'ROLE_MANAGER_PROJECT'
export const MANAGER_GROUP_CLIENT = 'ROLE_MANAGER_CLIENT'
export const MANAGER_GROUP_VENDOR = 'ROLE_MANAGER_VENDOR'

export const MANAGER_GROUPS = [
  { label: 'Admin manager', value: MANAGER_GROUP_ADMIN },
  { label: 'Finance manager', value: MANAGER_GROUP_FINANCE },
  { label: 'Project manager', value: MANAGER_GROUP_PROJECT },
  { label: 'Client manager', value: MANAGER_GROUP_CLIENT },
  { label: 'Vendor manager', value: MANAGER_GROUP_VENDOR },
]

export const getGroupNameFromType = (type) => {
  if (type) {
    return MANAGER_GROUPS.find((u) => u.value == type)?.label
  }
  return ''
};

export const getUserNameFromType = (type) => {
  if (type) {
    return USER_TYPES.find((u) => u.value == type)?.label
  }
  return ''
}

/**
 * Task related constants
 */
export const JOB_STATUS_COMPLETED = 'Completed'
export const JOB_STATUS_DELIVERED = 'Delivered'

export const TASK_STATUS_UNASSIGNED = 'Unassigned'
export const TASK_STATUS_PENDING = 'Pending'
export const TASK_STATUS_DRAFT = 'Draft'
export const TASK_STATUS_OFFERED = 'Offered'
export const TASK_STATUS_NEGOTIATING = 'Negotiating'
export const TASK_STATUS_CONFIRMED = 'Confirmed'
export const TASK_STATUS_IN_PROGRESS = 'In Progress'
export const TASK_STATUS_COMPLETED = 'Completed'
export const TASK_STATUS_REJECTED = 'Rejected'

export const TASK_STATUS_FOR_VENDORS = [
  { label: TASK_STATUS_PENDING, value: TASK_STATUS_PENDING, color: 'red' },
  {
    label: TASK_STATUS_CONFIRMED,
    value: TASK_STATUS_CONFIRMED,
    color: 'green',
  },
  {
    label: TASK_STATUS_IN_PROGRESS,
    value: TASK_STATUS_IN_PROGRESS,
    color: 'blue',
  },
  {
    label: TASK_STATUS_COMPLETED,
    value: TASK_STATUS_COMPLETED,
    color: 'green'
  }
]

export const TASK_STATUS = [
  {
    label: TASK_STATUS_UNASSIGNED,
    value: TASK_STATUS_UNASSIGNED,
    color: 'red',
  },
  { label: TASK_STATUS_DRAFT, value: TASK_STATUS_DRAFT, color: 'red' },
  /*    { label: TASK_STATUS_PENDING, value: TASK_STATUS_PENDING, color: "red" },*/
  { label: TASK_STATUS_OFFERED, value: TASK_STATUS_OFFERED, color: 'yellow' },
  {
    label: TASK_STATUS_NEGOTIATING,
    value: TASK_STATUS_NEGOTIATING,
    color: 'yellow'
  },
  {
    label: TASK_STATUS_CONFIRMED,
    value: TASK_STATUS_CONFIRMED,
    color: 'green'
  },
  {
    label: TASK_STATUS_IN_PROGRESS,
    value: TASK_STATUS_IN_PROGRESS,
    color: 'blue'
  },
  {
    label: TASK_STATUS_COMPLETED,
    value: TASK_STATUS_COMPLETED,
    color: 'green'
  },
  { label: TASK_STATUS_REJECTED, value: TASK_STATUS_REJECTED, color: 'red' },
]

/**
 * Calendar related constants
 */
export const days = [
  { order: 0, value: 'Monday' },
  { order: 1, value: 'Tuesday' },
  { order: 2, value: 'Wednesday' },
  { order: 3, value: 'Thursday' },
  { order: 4, value: 'Friday' },
  { order: 5, value: 'Saturday' },
  { order: 6, value: 'Sunday' },
]

export const getDayOrder = (day) => {
  if (days.some((e) => e.value === day)) {
    return days.find((e) => e.value === day).order
  }

  return -1
}

export const weekDays = days.slice(0, 5)
/*
export const LANGUAGE_TYPE_NONE = "None";
export const LANGUAGE_TYPE_SINGLE = "Single";
export const LANGUAGE_TYPE_PAIR = "Pair";
*/
export const CURRENCY_DEFAULT = 2

export const TASK_RUSH_TYPE_NONE = 'None'
export const TASK_RUSH_TYPE_VENDOR = 'Vendor'
export const TASK_RUSH_TYPE_CLIENT = 'Client'
export const TASK_RUSH_TYPE_BOTH = 'Both'
export const TASK_RUSH_TYPES = [
  TASK_RUSH_TYPE_NONE,
  TASK_RUSH_TYPE_VENDOR,
  TASK_RUSH_TYPE_CLIENT,
  TASK_RUSH_TYPE_BOTH,
]

export const QTASK_RUSH_TYPE_NONE = 'None'
export const QTASK_RUSH_TYPE_CLIENT = 'Client'
export const QTASK_RUSH_TYPES = [QTASK_RUSH_TYPE_NONE, QTASK_RUSH_TYPE_CLIENT]

export const BETA_UPDATE_VENDOR = true

export const TASK_BALANCE_STATUS_EXTERNAL = 'External'
export const TASK_BALANCE_STATUS_UNCOMPENSATED = 'Uncompensated'
export const TASK_BALANCE_STATUS_COMPENSATED = 'Compensated'
